import { Router, UrlTree } from '@angular/router';
import { ISideMenuItem } from './../../side-menu';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-side-menu-item',
  templateUrl: './side-menu-item.component.html',
  styleUrls: ['./side-menu-item.component.less'],
})
export class SideMenuItemComponent implements OnInit {
  @Input('value') menu!: ISideMenuItem;
  @Input() isSideMenuExpanded = false;

  @Output() expanded: EventEmitter<void> = new EventEmitter();
  @Output() collapsed: EventEmitter<void> = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit(): void {}

  navigate(route: string): void {
    const url: UrlTree = this.router.createUrlTree([route]);

    window.open(url.toString(), '_blank');
  }

  toggle(): void {
    this.menu.expanded = !this.menu.expanded;
    this.menu.expanded ? this.expanded.emit() : this.collapsed.emit();
  }
}
